<template>
    <el-popover
        v-show="userInfo.customer"
        placement="bottom-end"
        :width="320"
        trigger="hover"
        popper-style="padding:0;"
        popper-class="user-popper"
        :show-arrow="false"
        :hide-after="100"
        @after-leave="onUserAfterLeave"
    >
        <template #reference>
            <div class="header-right">
                <div class="user">
                    <div class="user-name d-flex align-items-center">
                        <div class="auth-msg d-flex align-items-center">
                            <div v-if="getUserShowText()" class="auth-text">
                                {{ getUserShowText() }}
                            </div>
                            <div v-else class="auth-phone">
                                {{ userInfo?.customer?.mobile }}
                            </div>
                            <el-image
                                v-if="getMemberImg(accountStore.proxyActualAccount) && isChainCloud"
                                class="member-level-img ml-4"
                                :src="getMemberImg(accountStore.proxyActualAccount)"
                            />
                        </div>
                    </div>
                </div>
                <img v-if="avatarUrl && accountStore.isRootAccount" :src="avatarUrl" alt="" class="user-logo" />
                <img v-else :src="tenant.theme.accountAvatar" alt="" class="user-logo" />
            </div>
        </template>
        <template #default>
            <div class="popover-user-info">
                <div class="user-info--top">
                    <img v-if="avatarUrl && accountStore.isRootAccount" :src="avatarUrl" alt="" class="user-logo" />
                    <img v-else :src="tenant.theme.accountAvatar" alt="" class="user-logo" />
                    <div class="user-info">
                        <div class="institution">
                            <div class="user-name">
                                {{ getUserShowText() || userInfo?.customer?.mobile }}
                                <span v-if="getUserShowText()" class="iconfont icon-yirenzheng" />
                                <el-image
                                    v-if="
                                        getMemberImg(accountStore.proxyActualAccount) &&
                                        getUserShowText() &&
                                        isChainCloud
                                    "
                                    class="member-level-img ml-4"
                                    :src="getMemberImg(accountStore.proxyActualAccount)"
                                />
                            </div>
                            <div v-if="accountStore.accountTypeDesc" class="role">
                                {{ accountStore.accountTypeDesc }}
                            </div>
                        </div>
                        <div v-if="getUserShowText()" class="mobile">
                            {{ userInfo?.customer?.mobile }}
                        </div>
                    </div>
                </div>
                <!--                <div-->
                <!--                    :class="isChainCloud ? 'user-balance balance' : 'user-balance balance-clone'"-->
                <!--                    @click="toMePage('account')"-->
                <!--                >-->
                <!--                    <div class="money">账户余额</div>-->
                <!--                    <div class="money-symbol">-->
                <!--                        <span class="money-word">{{ balanceSign }}</span>-->
                <!--                        <span>¥</span>-->
                <!--                        <span class="money-word">{{ formatNumber(Math.abs(customerAccount?.balance || 0), 2) }}</span>-->
                <!--                    </div>-->
                <!--                </div>-->
                <div class="line" />
                <div class="user-menu" @click="toMePage('info')"><i class="iconfont icon-_tuceng_11" />账号管理</div>
                <div v-if="isChainCloud" class="member-menu" @click="toMePage('member')">
                    <i class="iconfont icon-wodehuiyuan" />我的会员
                </div>
                <el-popover
                    placement="left"
                    :width="300"
                    trigger="click"
                    :teleported="false"
                    :hide-after="0"
                    :visible="enterpriseVisible"
                    @before-enter="onMouseEnter"
                >
                    <template #reference>
                        <div class="user-menu" @click="onClickChangeEnterprise">
                            <i class="iconfont icon-qiehuanqiye" />切换企业
                        </div>
                    </template>
                    <div>
                        <div
                            v-for="(item, index) in enterpriseList"
                            :key="item.proxyAccountId"
                            class="enterprise-wrap"
                            :class="enterpriseIndex === index ? 'active' : ''"
                            @click="onClickEnterprise(index, item)"
                        >
                            <span class="name">
                                {{ item.enterpriseName }}
                            </span>
                            <span v-if="enterpriseIndex === index" class="iconfont icon-Vector" />
                        </div>
                    </div>
                </el-popover>
                <div class="line" />
                <div class="logout" @click="logout"><i class="iconfont icon-tuichu" /><span>退出登录</span></div>
            </div>
        </template>
    </el-popover>
</template>
<script setup lang="ts">
import type { Ref } from "vue";
import type { Customer, CustomerVo } from "@zhihaoscm/entity";
import { loginService } from "@/api/loginService";
import { fileService } from "@/api/fileService";
import Tenant from "@/function/tenant";
import { MEMBER_LEVEL, MEMBER_STATE } from "@zhihaoscm/meta";
import { subManagementService } from "@/api/subManagementService";
import type { CustomerEnterpriseVo } from "@zhihaoscm/entity";
import { getUserInfo, openConsoleAdminPage } from "@/utils/common";
import { useUserStore } from "@/stores/user";
import { useAccountStore } from "@/stores/account";
import { getPublicFileUrl } from "@/utils";
import { cloneDeep } from "lodash-es";

const router = useRouter();
const tenant = Tenant.getInstance();
const userStore = useUserStore();
const avatarUrl = ref("");
const isChainCloud = Tenant.getInstance().isChainCloud;
const accountStore = useAccountStore();
// const setCustomerAccount = async () => {
//     if (!accountStore.proxyActualAccount.id) return;
//     customerAccount.value = await customerService.getCustomerAccount(accountStore.proxyActualAccount.id);
//     if (customerAccount.value?.balance < 0) {
//         balanceSign.value = "-";
//     }
// };

const userInfo: Ref<CustomerVo> = computed(() => userStore.userInfo);
const getUserShowText = () => {
    if (accountStore.isSubAccount) {
        return (userStore.userInfo as any).proxyAccount.institutionName;
    } else {
        return userStore?.userInfo?.customer?.institutionName || userStore?.userInfo?.customer?.realName;
    }
};
const logout = async () => {
    await loginService.logout();
    userStore.clear();
    ElMessage.success("已退出登录");
    await nextTick();
    openConsoleAdminPage("/", false);
};

const toMePage = (path: string) => {
    window.open(`${window.location.origin}/console/me/${path}`);
};

// 获取用户头像
const getAvatar = async () => {
    await getUserInfo();
    const avatarFileId: number = userInfo.value.customer.avatarFileId;
    if (avatarFileId) {
        const file = await fileService.getFileById(Number(avatarFileId));
        avatarUrl.value = file.path;
    }
};

const getMemberImg = (customer?: Customer) => {
    if (!customer) return;
    if (customer.memberState === MEMBER_STATE.EXPIRY.code) return;
    let imgPath = "";
    switch (customer.memberLevel) {
        case MEMBER_LEVEL.PENDING.code:
            break;
        case MEMBER_LEVEL.BASE.code:
            imgPath = getPublicFileUrl("base-level-medal.svg");
            break;
        case MEMBER_LEVEL.SENIOR.code:
            imgPath = getPublicFileUrl("senior-level-medal.svg");
            break;
        // case MEMBER_LEVEL.ENTERPRISE_GRADE.code:
        //     imgPath = getPublicFileUrl("enterprise-level-medal.svg");
        //     break;
    }
    return imgPath;
};

/** 切换企业，切换身份 */
const enterpriseList = ref<{ proxyAccountId: number; enterpriseName: string }[]>([]);
const enterpriseIndex = ref(-1);
// 设置企业列表
const setEnterpriseList = async () => {
    const result = [{ proxyAccountId: userStore.userInfo.customer.id, enterpriseName: "我的企业-未认证" }];
    // 如果用户企业认证了
    if (userStore.userInfo.customer.institutionName)
        result[0].enterpriseName = userStore.userInfo.customer.institutionName;
    // 查询受邀记录为已确认的数据
    const data: CustomerEnterpriseVo[] = await subManagementService.getSubInvitedList();
    data?.forEach((item: CustomerEnterpriseVo) => {
        result.push({
            proxyAccountId: item.account?.id,
            enterpriseName: item.account?.institutionName
        });
    });
    enterpriseList.value = cloneDeep(result);
    setEnterpriseIndex();
};
const setEnterpriseIndex = () => {
    const proxyAccountId = accountStore?.proxyActualAccount?.id
        ? accountStore?.proxyActualAccount?.id
        : userStore.proxyAccountId;
    const index = enterpriseList.value.findIndex(item => item.proxyAccountId === proxyAccountId);
    enterpriseIndex.value = index >= 0 ? index : 0;
};
const onClickEnterprise = (index: number, item: { proxyAccountId: number; enterpriseName: string }) => {
    enterpriseIndex.value = index;
    loginSwitchProxy(item.proxyAccountId);
};
const loginSwitchProxy = async (proxyAccountId: number) => {
    await loginService.loginSwitchProxy(proxyAccountId);
    userStore.setProxyAccountId(proxyAccountId);
    await getUserInfo();
    onUserAfterLeave();
    router.go(0);
};

/** -------------弹出框交互优化------------- */
// 移除一级弹出层他、隐藏动画前的钩子函数
const onUserAfterLeave = () => {
    enterpriseVisible.value = false;
};
// 鼠标移入切换企业的时候
const onMouseEnter = () => {
    setEnterpriseIndex();
};
// 是否显示企业弹出框
const enterpriseVisible = ref(false);
const onClickChangeEnterprise = () => {
    enterpriseVisible.value = true;
};

onMounted(async () => {
    if (accountStore.isRootAccount) await getAvatar();
    await setEnterpriseList();
    // await setCustomerAccount();
});
</script>

<style lang="scss">
.el-popper:has(.popover-user-info) {
    position: relative;
    padding: 12px 8px 0 12px !important;
    border-radius: 8px;
    background: #fff;
    box-shadow: 0 6px 20px 0 #165dff0d;
    border: 1px solid #d3d3d3;
}
</style>
<style scoped lang="scss">
@use "./index.scss";
</style>
